import styled from 'foundations-theming/utils';

export const StyledIcon = styled.svg<{
  $size: string;
  $color: string;
  $alignWithText: boolean;
}>(({ $size, $color, $alignWithText }) => {
  return {
    inlineSize: $size,
    blockSize: $size,
    fill: $color,

    ...($alignWithText && {
      verticalAlign: '-0.1em', // This value was chosen based on the icon svg alignment within its viewbox
    }),
  };
});
